import { render, staticRenderFns } from "./BoardGrid.vue?vue&type=template&id=ed90a152&scoped=true&"
import script from "./BoardGrid.vue?vue&type=script&lang=js&"
export * from "./BoardGrid.vue?vue&type=script&lang=js&"
import style0 from "./BoardGrid.vue?vue&type=style&index=0&id=ed90a152&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed90a152",
  null
  
)

export default component.exports